export default __webpack_public_path__ + "static/media/logoWhite.3fee0f85.svg";